import React from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import Loading from '@tencent/dui/lib/components/Loading';
import i18n from '@i18next/i18n';
import styles from './template-beautify-style.less';
import { IChangeTemplateService, PaymentRequirementType } from '@src/slide/application/service/change-template-service/index.interface';
import { IReactionDisposer, reaction } from 'mobx';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { TemplatePreviewList } from '@src/slide/application/service/change-template-service/component/template-preview-list';
import {
    TemplateSelectList,
} from '@src/slide/application/service/change-template-service/component/template-select-list';
import { IPresentationData } from '@tencent/slide-sdk-model';
import classNames from 'classnames';
import BeautifyNavigation from '@src/slide/application/service/change-template-service/component/beautify-navigation';
import {
    fetchTemplateById,
    fetchTemplateByIdByNonVip,
} from '@src/slide/application/service/ai-ssistant/ai-generator/fetch-template';
import { convert } from '@tencent/slide-markdown-converter';
import cloneDeep from 'lodash/cloneDeep';
import { isSVip, isVip } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { getAidForReport } from '@tencent/txdocs-aid';
import { openPay } from '@src/js/common/ark-extensions/dc-components/pay';

interface ITemplateBeautifyProps {
    uiDataService: IUiDataService;
    changeTemplateService: IChangeTemplateService;
    aid: string;
    onDialogVisibleChange(visible: boolean): void;
}

interface ITemplateBeautifyState {
    selectedTemplateId: string;
    dialogVisible: boolean;
    templateUiDataService?: IUiDataService,
    previewUiDataService: IUiDataService,
    isLoading: boolean;
}

/**
 * 一键换肤弹窗
 */
export default class TemplateBeautifyDialog extends React.Component<ITemplateBeautifyProps, ITemplateBeautifyState> {
    private reaction: IReactionDisposer;
    private reaction2: IReactionDisposer;
    private vipTemplateMap = new Map<string, PaymentRequirementType>();

    constructor(props) {
        super(props);
        this.state = {
            dialogVisible: this.props.changeTemplateService.dialogVisible,
            templateUiDataService: undefined,
            selectedTemplateId: '',
            isLoading: false,
            previewUiDataService: this.props.uiDataService,
        };
        this.initEvent();
    }

    public componentDidUpdate(
        prevProps: Readonly<ITemplateBeautifyProps>,
        prevState: Readonly<ITemplateBeautifyState>,
        snapshot?: any,
    ) {
        if (this.props.uiDataService !== prevState.previewUiDataService) {
            this.setState({
                previewUiDataService: this.props.uiDataService,
            });
        }
    }

    public componentDidMount() {
    }

    public componentWillUnmount() {
        this.reaction?.();
        this.reaction2?.();
    }

    render() {
        const { slideWidth, slideHeight } = this.props.uiDataService.presentation.props;

        return <Modal
            zIndex={9999}
            destroyOnClose={true}
            title={<ModalTitle
                title={i18n.t('更多模板')}
            />}
            onCancel={this.onCancel}
            style={{
                padding: 0,
                width: 1001,
            }}
            footer={null}
            className={classNames({
                [styles['template-modal-container']]: true,
                'slide-template-modal-container-for-global': true,
            })}
            visible={this.state.dialogVisible}>
            <div
                onContextMenu={(e) => {
                    e.preventDefault();
                }}
                className={styles['template-dialog-container']}>
                {/* <BeautifyNavigation />*/}
                <div
                    className={styles['template-dialog-operation-area-container']}
                >
                    <TemplateSelectList
                        selectedTemplateId={this.state.selectedTemplateId}
                        isLoading={this.state.isLoading}
                        changeTemplateService={this.props.changeTemplateService}
                        onTemplateSelect={(id, vipType) => {
                            this.vipTemplateMap.set(id, vipType);
                            this.handleTemplateSelect(id);
                        }}
                    />
                </div>
                <TemplatePreviewList
                    onClick={async () => {
                        await this.handleTemplateOk();
                    }}
                    showVipGuideButton={this.getIsVipButton()}
                    isVipTemplate={this.getIsVipTemplate()}
                    onUndo={this.revertPreview}
                    selectedTemplateId={this.state.selectedTemplateId}
                    isLoading={this.state.isLoading}
                    cloneUiDataService={this.state.previewUiDataService}
                    templateUiDataService={this.state.templateUiDataService}
                    slideHeight={slideHeight}
                    slideWidth={slideWidth}
                />
            </div>
        </Modal>;
    }

    private getIsVipButton = () => {
        const vipType = this.vipTemplateMap.get(this.state.selectedTemplateId);
        return (vipType === PaymentRequirementType.FreeForVIP && !isVip())
            || (vipType === PaymentRequirementType.FreeForSuperVIP && !isSVip());
    };

    private getIsVipTemplate = () => {
        const vipType = this.vipTemplateMap.get(this.state.selectedTemplateId);
        return vipType === PaymentRequirementType.FreeForVIP
            || vipType === PaymentRequirementType.FreeForSuperVIP;
    };

    private revertPreview = async () => {
        const previewUiDataService = await this.props.changeTemplateService.revertPreviewSlide();
        this.setState({
            selectedTemplateId: '',
            previewUiDataService,
        });
    };

    private ddd = (vipType) => {
    };

    private vipGuide = () => {
        openPay(this.props.aid);
    };


    /**
     * 选择主题，启动模版预览/文档美化
     * @param templateId
     */
    private handleTemplateSelect = async (templateId: string) => {
        const { changeTemplateService } = this.props;
        this.setState({
            isLoading: true,
            selectedTemplateId: templateId,
        });

        // 给个100是为了不阻塞loading动画，没啥业务问题，对比下比requestAnimation效果更好
        setTimeout(async () => {
            const newPresentationData = await this.props.changeTemplateService.getPresentationByCached(templateId);

            // 获取一个独立的uiData用于模版预览，不应参与美化填充
            const { cloneUiDataService } = await changeTemplateService.createTemplateUiDataService(newPresentationData);

            // 美化预览
            const previewUiDataService = await changeTemplateService.previewBeautifyUi(
                templateId,
                newPresentationData,
                true,
            );

            this.setState({
                templateUiDataService: cloneUiDataService,
                isLoading: false,
                previewUiDataService,
            });
        }, 100);
    };

    private handleTemplateOk = async () => {
        if (this.getIsVipButton()) {
            this.vipGuide();
            return;
        }

        if (this.props.changeTemplateService.hasCommentOnReplaceSlide) {
            Modal.confirm({
                title: i18n.t('应用美化'),
                content: i18n.t('美化后部分页面批注会丢失，且不可撤销。确认美化吗？'),
                okText: i18n.t('确认'),
                onOk: this.confirmTemplateOk,
                zIndex: 10000,
            });
        } else {
            await this.confirmTemplateOk();
        }
    };

    private confirmTemplateOk = async () => {
        const load = Loading.show({ tip: i18n.t('加载中...') });
        const { changeTemplateService } = this.props;
        await changeTemplateService.updateTemplateToSlide(this.state.selectedTemplateId);


        requestAnimationFrame(() => {
            this.onCancel();
            this.setState({
                selectedTemplateId: '',
            });
            setTimeout(() => {
                load.close();
            }, 1000);
        });
    };

    private onCancel = () => {
        this.revertPreview();
        this.closeModal();
    };

    private updateComponent = () => {
        this.forceUpdate();
    };

    private closeModal = () => {
        this.props.changeTemplateService.closeTemplateBeautifyDialog();
    };

    /**
     * 选择主题，会触发主题映射
     * @param theme
     * @param selectedKey
     */
    private handleThemeSelect = async () => {
    };

    /**
     * 保存选择主题
     */
    private handleOk = async () => {
    };

    private handleSnackbar = () => {
    };

    private initEvent = () => {
        this.reaction = reaction(() => this.props.changeTemplateService.dialogVisible, (visible) => {
            this.setState({
                dialogVisible: visible,
            });
        });

        // this.reaction2 = reaction(() => this.props.changeTemplateService.previewUiDataService, async (uiData) => {
        //     this.setState({
        //         previewUiDataService: uiData,
        //     });
        // });
    };
}

interface IModalTitleProps {
    title: string;
}

export class ModalTitle extends React.Component<IModalTitleProps, any> {
    render() {
        return <div className={styles['modal-title-container']}>
            <div
                className={styles['modal-title-wrapper']}
            >
                { this.props.title }
            </div>
        </div>;
    }
}
